import React from 'react';
import { Tooltip } from 'antd';
import './roundedButton.css';

function RoundedBtn({ icon, onClick, tooltip }) {
	return (
		<>
			<Tooltip title={tooltip}>
				<button className="rounded-btn" onClick={onClick}>
					{icon}
				</button>
			</Tooltip>
		</>
	);
}

export default RoundedBtn;
